var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 29,
    viewBox: "0 0 118 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7371 27.2005H21.2225L19.2077 22.2172H8.26067L6.44735 27.2005H0L9.80535 2.00714H16.8571L27.7371 27.2005ZM13.432 8.02862L9.87251 17.7876H17.3944L13.432 8.02862Z",
    fill: "#DBDBD5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5118 2.00714H56.8174V27.2005H50.7058V11.4892L44.1242 19.3795H43.1839L36.6023 11.4892V27.2005H30.5579V2.00714H35.8635L43.654 11.3508L51.5118 2.00714Z",
    fill: "#DBDBD5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.197 2.00714C81.1293 2.00714 85.6961 7.75177 85.6961 14.6038C85.6961 21.8019 81.2636 27.1312 71.5254 27.1312H61.4514V2.00714H72.197ZM67.4958 22.5632H71.4582C77.5698 22.5632 79.3831 18.2721 79.3831 14.6038C79.3831 10.3126 77.0997 6.64437 71.3911 6.64437H67.4958V22.5632Z",
    fill: "#DBDBD5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.277 7.89021H97.7849L90.1287 0.0692124L118 0V28.7924L110.277 20.6945V7.89021Z",
    fill: "#DBDBD5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.7847 20.9714V9.34369L89.8599 17.5108V29H101.344L109.135 20.9714H97.7847Z",
    fill: "#DBDBD5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmd);
export default __webpack_public_path__ + "static/media/amd.4705b91068a0bd078f85768815c4c93b.svg";
export { ForwardRef as ReactComponent };